import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import SSLoader from './ssLoader';

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            phone: '',
            bannerText: '',
            imageUrl: '',
            navLinks: [],
            loading: true,
            error: null,
        };
    }

    async componentDidMount() {
        try {
            const [bannerRes, navRes] = await Promise.all([
                fetch(`${process.env.REACT_APP_API_URL}/api/globals/usa-banner`),
                fetch(`${process.env.REACT_APP_API_URL}/api/globals/navigation`),
            ]);

            if (!bannerRes.ok) throw new Error(`Banner fetch failed: ${bannerRes.status}`);
            if (!navRes.ok) throw new Error(`Navigation fetch failed: ${navRes.status}`);

            const bannerData = await bannerRes.json();
            const navData = await navRes.json();

            this.setState({
                email: bannerData.email || '',
                phone: bannerData.phone || '',
                bannerText: bannerData.text || '',
                imageUrl: bannerData?.image?.url || '',
                navLinks: navData.menu || [],   // ✅ FIX HERE
                // loading: false,
            }, () => {
                setTimeout(() => {
                    this.setState({ loading: false });
                }, 2000);
            });
        } catch (error) {
            this.setState({ error: error.message });
        }
    }

    render() {
        const { email, phone, bannerText, imageUrl, navLinks, error } = this.state;

        // if (loading) return <div className="footer">Loading...</div>;
        if (error) return <div className="footer text-danger">Error: {error}</div>;

        return (
            <div className="footer" style={{ backgroundColor: "#ecff19" }}>
                {/* Banner section */}
                <SSLoader loading={this.state.loading} />
                <div
                    className="made-in-usa py-3"
                    style={{
                        backgroundImage: imageUrl ? `url(${imageUrl})` : 'none',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                    }}
                >
                    <Container>
                        <Row className="align-items-center">
                            <Col lg="10" md="12" sm="12">
                                <h3 style={{ color: '#fff', textShadow: '1px 1px 3px rgba(0,0,0,0.6)' }}>
                                    {bannerText || '100% Made in the USA'}
                                </h3>
                            </Col>

                        </Row>
                    </Container>
                </div>

                {/* Footer content */}
                <Container className="py-4 footer-links">
                    <Row>
                        <Col lg="8" md="8" sm="12">
                            <h5>Sportstar</h5>
                            <p>Email: {email || 'N/A'}</p>
                            <p>Phone: {phone || 'N/A'}</p>
                        </Col>

                        <Col lg="4" md="4" sm="12">
                            <h5>Navigation</h5>
                            <ul className="list-unstyled">
                                {navLinks.map((link, idx) => (
                                    <li key={idx}>
                                        <a href={link.url} className="text-white text-decoration-none">
                                            {link.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default Footer;
